<script setup lang="ts">
import { nextTick, onMounted } from 'vue';
import config from './config/q3-config.json';

window.__Q3_CONFIG__ = config as unknown as Record<string, unknown>;

onMounted(async () => {
  await nextTick();
  await import('./legacy/runtime.js');
});
</script>

<template>
<div id="login" class="login">
    <div class="login-card">
      <h2>商务中心 Q3 人才盘点</h2>
      <p>2026年第三季度 · 多级独立评分与分层校准</p>
      <div class="login-audience-notice" role="note"><strong>仅限本轮评委登录</strong>，非评委账号无法进入。</div>
      <div class="field"><label for="loginCode">员工编号</label><input id="loginCode" autocomplete="off" placeholder="例如：XS0000"></div>
      <div class="field"><label for="loginPwd">密码</label><input id="loginPwd" type="password" autocomplete="current-password" placeholder="初始密码为员工编号 + 888"></div>
      <button id="loginBtn" class="btn btn-primary" style="width:100%;padding:12px">登录</button>
      <div id="loginError" class="login-error" role="alert" aria-live="assertive"></div>
    </div>
  </div>

  <main id="app" class="shell hidden">
    <div class="app-sticky-head">
      <header class="top">
        <div class="top-row">
          <div><h1>商务中心 Q3 人才盘点</h1><p>6、7、8月绩效参考 · 五维评分 · S/A比例校验 · 数据保密</p></div>
          <div class="top-actions"><span id="modePill" class="mode-pill"></span><span id="userPill" class="user-pill"></span><button id="syncBtn" class="btn btn-small btn-outline hidden" title="获取其他评委最新提交的评分、评级和部门 S+A 结果；当前草稿会继续保留">刷新最新结果</button><button id="changePasswordBtn" class="btn btn-small btn-outline">修改密码</button><button id="logoutBtn" class="btn btn-small btn-outline">退出</button></div>
        </div>
      </header>
      <div class="nav-row"><nav id="nav" class="nav"></nav><span id="navAutosave" class="nav-autosave hidden">自动保存已开启</span></div>
    </div>

    <section id="panel-score" class="panel"></section>
    <section id="panel-calibrate" class="panel"></section>
    <section id="panel-results" class="panel"></section>
    <section id="panel-audit" class="panel"></section>
  </main>
  <div id="saveIndicator" class="save-indicator" role="status" aria-live="polite">已保存草稿</div>
  <div id="toast" class="toast" role="status" aria-live="polite"></div>
  <div id="modalRoot"></div>
</template>
